export const TEMPLATE_WIDTH = 1440
export const TEMPLATE_HEIGHT = 810

const clearCanvas = (ctx, containerRect) =>
  ctx.clearRect(0, 0, containerRect.width, containerRect.height)

export function drawGuides(ctx, containerRect, frameEls) {
  if (!ctx) return

  // Display px distances in terms of 1440x810 template size
  const horizontalTemplatePx = (value) =>
    Math.round((value / containerRect.width) * TEMPLATE_WIDTH)
  const verticalTemplatePx = (value) =>
    Math.round((value / containerRect.height) * TEMPLATE_HEIGHT)

  function textBox(text, x, y, { yEnd, xEnd } = {}) {
    const textWidth = ctx.measureText(text).width
    const fontSize = 12
    const padding = 4

    if (xEnd) x = xEnd - (textWidth + 2 * padding)
    if (yEnd) y = yEnd - (fontSize + 2 * padding)

    ctx.fillStyle = '#63ff78'
    ctx.fillRect(x, y, textWidth + 2 * padding, fontSize + 2 * padding)
    ctx.fillStyle = '#000'
    ctx.font = `${fontSize}px sans-serif`
    ctx.fillText(text, x + padding, y + fontSize + padding - 1)
  }

  clearCanvas(ctx, containerRect)
  frameEls.forEach((el) => {
    let { top, bottom, left, right } = el.getBoundingClientRect()
    top -= containerRect.top
    bottom -= containerRect.top
    left -= containerRect.left
    right -= containerRect.left
    const x = left + (right - left) / 2
    const y = top + (bottom - top) / 2

    // Alignment guide lines
    ctx.beginPath()
    ctx.strokeStyle = '#63ff78'
    ctx.lineWidth = 1
    ctx.moveTo(x, top)
    ctx.lineTo(x, 0)
    ctx.stroke()
    ctx.moveTo(x, containerRect.height)
    ctx.lineTo(x, bottom)
    ctx.stroke()
    ctx.moveTo(0, y)
    ctx.lineTo(left, y)
    ctx.stroke()
    ctx.moveTo(right, y)
    ctx.lineTo(containerRect.width, y)
    ctx.stroke()

    // Alignment px distance boxes
    textBox(horizontalTemplatePx(left), null, y + 5, { xEnd: left - 50 })
    textBox(horizontalTemplatePx(ctx.canvas.clientWidth - right), right + 50, y + 5)
    textBox(verticalTemplatePx(top), x + 5, null, { yEnd: top - 50 })
    textBox(verticalTemplatePx(ctx.canvas.clientHeight - bottom), x + 5, bottom + 50)
  })
}

export function initCanvas(canvas, displayEl) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#correcting_resolution_in_a_canvas
  const ctx = canvas.getContext('2d')
  canvas.style.width = `${displayEl.clientWidth}px`
  canvas.style.height = `${displayEl.clientHeight}px`
  const scale = window.devicePixelRatio
  canvas.width = Math.floor(displayEl.clientWidth * scale)
  canvas.height = Math.floor(displayEl.clientHeight * scale)
  ctx.scale(scale, scale)
  const containerRect = canvas.getBoundingClientRect()

  return { ctx, containerRect }
}

export function hasOverlaps(containerRect, offsetRectOrEl, otherEls) {
  return false // Temporarily disabled 12/8/2022
  // let offsetRect
  // if (offsetRectOrEl instanceof Element) {
  //   offsetRect = generateOffsetRect(containerRect, offsetRectOrEl.getBoundingClientRect())
  // } else {
  //   offsetRect = offsetRectOrEl
  // }

  // const otherRects = otherEls.map((el) =>
  //   el.$el ? el.$el.getBoundingClientRect() : el.getBoundingClientRect()
  // )
  // return otherRects.some((otherRect) => {
  //   const otherOffsetRect = generateOffsetRect(containerRect, otherRect)
  //   const overlapsY =
  //     (offsetRect.top >= otherOffsetRect.top &&
  //       offsetRect.top <= otherOffsetRect.bottom) ||
  //     (offsetRect.bottom >= otherOffsetRect.top &&
  //       offsetRect.bottom <= otherOffsetRect.bottom)
  //   const overlapsX =
  //     (offsetRect.left >= otherOffsetRect.left &&
  //       offsetRect.left <= otherOffsetRect.right) ||
  //     (offsetRect.right >= otherOffsetRect.left &&
  //       offsetRect.right <= otherOffsetRect.right)
  //   return overlapsX && overlapsY
  // })
}

const TOLERANCE = 0.01
function checkSixteenNine(file) {
  const isVideo = file.type.includes('video')

  return new Promise((resolve) => {
    if (isVideo) {
      const videoEl = document.createElement('video')
      videoEl.src = window.URL.createObjectURL(file)
      videoEl.onloadedmetadata = () => {
        window.URL.revokeObjectURL(videoEl.src)
        const { videoWidth, videoHeight } = videoEl
        resolve(Math.abs(videoWidth / videoHeight - 16 / 9) < TOLERANCE)
      }
    } else {
      const imageEl = document.createElement('img')
      imageEl.src = window.URL.createObjectURL(file)
      imageEl.onload = () => {
        window.URL.revokeObjectURL(imageEl.src)
        const { naturalWidth, naturalHeight } = imageEl
        resolve(Math.abs(naturalWidth / naturalHeight - 16 / 9) < TOLERANCE)
      }
    }
  })
}

const VALID_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/svg',
  'video/mp4',
  'video/mov',
])
export async function validateFile(file) {
  if (!file) throw new Error('Please select a file')

  if (!VALID_TYPES.has(file.type)) {
    throw new Error('Valid file types: gif jpeg png svg mp4 or mov')
  }
  if (file.size / 1024 / 1024 > 100) {
    throw new Error('File size must be less than 100MB')
  }
  const isSixteenNine = await checkSixteenNine(file)
  if (!isSixteenNine) {
    throw new Error('Please select a file with 16:9 aspect ratio')
  }

  return {
    contentType: file.type,
    image: file,
  }
}
